
import TableList from "@components/templates/tablelist";
import { HttpTransactionList, HttpExportTransaction, HttpChangeTransactionStatus } from "@/service/billing";
import { mapGetters } from "vuex";
import compUpdate from "./update";
import mixin from "./mixin";
export default {
    mixins: [TableList, mixin],
    components: {
        compUpdate,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            formData: {

            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpTransactionList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "edit":
                    this.operate = {
                        show: true,
                        params: { id: params, type: 'edit' },
                        title: this.$t('global.common.edit', { defaultValue: "编辑" }),
                        component: 'compUpdate',
                        width: 'middle',
                        showFooter: false,
                    }
                    break;
                case "add":
                    this.operate = {
                        show: true,
                        params: { type: 'add' },
                        title: this.$t('global.common.add', { defaultValue: "添加" }),
                        component: 'compUpdate',
                        width: 'middle',
                        showFooter: false,
                    }
                    break;
                case "inactive":
                    this.operate = {
                        show: true,
                        alert: "warning",
                        params: { ids: params, status: "STATUS_INACTIVE" },
                        title: this.$t('fbb.alloment.loss_effect', { defaultValue: "失效" }),
                        ajaxRequest: HttpChangeTransactionStatus,
                    }
                    break;
                case "active":
                    this.operate = {
                        show: true,
                        alert: "warning",
                        params: { ids: params, status: "STATUS_ACTIVE" },
                        title: this.$t('fbb.accountmanage.active', { defaultValue: "激活" }),
                        ajaxRequest: HttpChangeTransactionStatus,
                    }
                    break;
                case 'export':
                    this.handleWebfs(HttpExportTransaction, this.formData, { executor: 'request', download: true });
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, status } = row,
                isActive = 'STATUS_ACTIVE' == status;
            return [{
                label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                show: true,
                params: id,
                operate: 'edit'
            }, {
                label: this.$t('fbb.alloment.loss_effect', { defaultValue: '失效' }),
                show: isActive,
                params: id,
                operate: 'inactive'
            }, {
                label: this.$t('fbb.accountmanage.active', { defaultValue: '激活' }),
                show: !isActive,
                params: id,
                operate: 'active'
            }]
        },
    },
    computed: {
        // ...mapGetters('dictionary', ['getWarehouseAllList']),
        ToolsData() {
            return [
                {
                    label: this.$t('global.common.add', { defaultValue: "添加" }),
                    operate: "add",
                    theme: "primary",
                },
                {
                    label: this.$t('global.common.export', { defaultValue: "导出" }),
                    operate: "export",
                    theme: "info",
                },
                {
                    label: this.$t('fbb.accountmanage.muti_loss_effect', { defaultValue: "批量失效" }),
                    operate: "inactive",
                    theme: "primary",
                    batch: true,
                    more: true,
                },
                {
                    label: this.$t('fbb.accountmanage.muti_active', { defaultValue: "批量激活" }),
                    operate: "active",
                    theme: "primary",
                    batch: true,
                    more: true,
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.accountmanage.thing_name', { defaultValue: "事务项名称" }),
                    tag: 'vInput',
                    key: 'EQ_transactionName',
                    show: true,
                },
                {
                    label: this.$t('fbb.accountmanage.thing_code', { defaultValue: "事务项Code" }),
                    tag: 'vInput',
                    key: 'EQ_transactionCode',
                    show: true,
                },
                {
                    label: this.$t('global.common.status', { defaultValue: "状态" }),
                    tag: 'vSelect',
                    key: 'EQ_status',
                    options: this.getStatus,
                    show: true,
                },
            ]
        },
        columns() {
            return [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            }, {
                title: this.$t('global.common.operation', { defaultValue: '操作' }),
                maxWidth: 90,
                render: this.getOperateNodes
            }, {
                title: this.$t('fbb.accountmanage.thing_name', { defaultValue: "事务项名称" }),
                key: 'transactionName',
            },
            {
                title: this.$t('fbb.accountmanage.thing_code', { defaultValue: "事务项Code" }),
                key: 'transactionCode',
            },
            {
                title: this.$t('fbb.accountmanage.cost_source', { defaultValue: '计费值来源' }),
                key: 'billingSourcesType',
                render: (h, { row }) => this.findRenderLabel(this.getSourcesType, row.billingSourcesType)
            },
            {
                title: this.$t('global.common.status', { defaultValue: '状态' }),
                key: 'status',
                render: (h, { row }) => this.findRenderLabel(this.getStatus, row.status)
            },
            {
                title: this.$t('fbb.accountmanage.description', { defaultValue: '描述' }),
                key: 'remark',
            },
            {
                title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                key: 'createdAt',
                sortable: true
            },
            ];
        },

    },

};
